jQuery(function($) {
    "use strict";

    function goog_snippet_vars ()
    {
        var w = window;
        w.google_conversion_id = 850839179;
        w.google_conversion_label = "_geuCJbr4HEQi43blQM";
        w.google_conversion_value = 1.00;
        w.google_conversion_currency = "EUR";
        w.google_remarketing_only = false;
    };
    // DO NOT CHANGE THE CODE BELOW.
    function goog_report_conversion(url)
    {
        goog_snippet_vars();
        window.google_conversion_format = "3";
        var opt = new Object();
        opt.onload_callback = function() {
            if (typeof(url) != 'undefined')
            { window.location = url; }
        }
        var conv_handler = window['google_trackConversion'];
        if (typeof(conv_handler) == 'function')
        { conv_handler(opt); }
    };

    // Variables
    var breakpt = 992,
        breakpt_sm = 540;

    var subcriber_tel_fixe = false;

    // Scroll to ID
    function scrollToId(id) {
        $('html,body').animate({
                scrollTop: $("#" + id).offset().top
            },
            500);
    }

    // TIMELINE - Step hover
    function timelineHover() {
        if ($(window).width() < breakpt) {
            $(this).closest('.step').siblings().find('.name-step').hide();
            $(this).closest('.step').find('.name-step').show();
        }
    }

    function timelineLeave() {
        if ($(window).width() < breakpt) {
            $('#timeline-souscription .name-step').hide();
            $('#timeline-souscription .current .name-step').show();
        }
    }

    // Display or hide form Benefit
    function displayBoolForm() {
        var innerForm = $(this).closest('.boolForm').parent().find(".innerForm"),
            checkForm = $(this).closest('.boolForm').parent().find(".checkForm"),
            addingForm = $(this).closest('.boolForm').parent().find(".addingForm");

        if ($('#contact_2').length) {
            $('#contact_2').hide();
        }

        if ($('.add-contact').length) {
            $('.add-contact').show();
        }

        if ($(this).val() == "false" || $(this).val() == 0) {
            if (innerForm.length) {

                innerForm.show();
            }
            if (addingForm.length) {
                addingForm.show();
            }
            if (checkForm.length) {

                checkForm.hide();
            }

            if ($(this).closest('form').attr('id') == 'form-benefit') {
                $('.subsIsBenefTitle1').html('Compléter les informations du bénéficiaire');
            }
            $('#form_tel_benefit').parent().parent().show();
        } else {
            if (innerForm.length) {
                innerForm.hide();
            }
            if (addingForm.length) {
                addingForm.hide();
            }
            if (checkForm.length) {
                checkForm.show();
            }
            if ($(this).closest('form').attr('id') == 'form-benefit') {
                $('.subsIsBenefTitle1').html('Veuillez saisir l\'adresse d\'installation du matériel et un téléphone fixe');
            }

            if (subcriber_tel_fixe == true) {
                $('#form_tel_benefit').parent().parent().hide();
            } else {
                $('#form_tel_benefit').parent().parent().show();
            }



        }
    }
    // Display form
    function displayElt(target) {
        $(target).show();
    }

    // Hide form
    function hideElt(target) {
        $(target).hide();
    }

    /*=====================================
    =            INIT FUNCTION            =
    =====================================*/

    $(document).ready(function() {

        // Print invoice
        $('#print-invoice').click(function() {
            window.print();
        });


        // variables
        var choice1 = false;
        var choice2 = false;
        var choice3 = false;
        var subsIsBenef = false;
        var subsIsContact = false;
        var secondContact = false;

        $(document).on('click', '.toggle-step a', function(e) {
            $(this).closest('.accordion-item').removeClass('completed').addClass('current');
            $(this).closest('.accordion-item').find('>.accordion-collapse').addClass('show');
            $(this).closest('.accordion-item').nextAll('.accordion-item').removeClass('current completed').addClass('disabled');
        });

        $(document).on('click', '#heading-step-1 .toggle-step a, #heading-step-2 .toggle-step a, #heading-step-3 .toggle-step a, #heading-step-4 .toggle-step a', function() {
            $('#timeline-souscription ul .step').removeClass('completed current').addClass('disabled');
            var index = $(this).closest('.accordion-item').index();
            $('#timeline-souscription .step').eq(index).addClass('current').removeClass('disabled');
        });


        $('.open-ss-step').click(function(e) {
            e.preventDefault();
            var target = $(this).attr('href');
            var parent_target = $(this).attr('data-step-target');
            var current_step = $(this).attr('data-step-current');

            $('.' + target).removeClass('disabled completed').addClass('current');
            $('.' + target).siblings().removeClass('completed current').addClass('disabled');
            $('#' + target).addClass('show');

            $('#' + parent_target).addClass('show').attr('aria-expanded', true);
            $('#' + parent_target).parent().addClass('current').removeClass('disabled completed');

            $('#' + current_step).removeClass('show').attr('aria-expanded', false);
            $('#' + current_step).closest('.accordion-item').removeClass('current').addClass('disabled');

            scrollToId(parent_target);
        });


        // Disable toggle for next steps in Timeline
        $('#timeline-souscription a[data-bs-toggle="collapse"]').click(function(e) {
            e.preventDefault();

            if ($(this).closest('.step').hasClass('disabled')) {
                e.stopPropagation();
            }
        });

        // TIMELINE - Step hover
        $('#timeline-souscription a[data-bs-toggle="collapse"]').mouseenter(timelineHover);
        $('#timeline-souscription').mouseleave(timelineLeave);

        // Display or hide boolean form
        $('.boolForm input').click(displayBoolForm);


        // Limited fields
        $('.limitedField').keydown(function(e) {
            var maxLength = $(this).attr('data-maxlength');
            var inputLength = $(this).val().length;

            if (e.keyCode != 8 && e.keyCode != 46 && e.keyCode != 9 && e.keyCode != 16) {
                if (inputLength >= maxLength) {
                    if ($(this).hasClass('fieldRib')) {
                        $(this).next('input').focus();
                    } else {
                        $(this).closest('.field-item').next().find('.field-item:first-child input').focus();
                    }
                    return false;
                }
            }
        });
        $('.limitedField').keyup(function(e) {
            if (e.keyCode != 9 && e.keyCode != 16) {
                var maxLength = $(this).attr('data-maxlength');
                var inputLength = $(this).val().length;

                if (inputLength >= maxLength) {
                    if ($(this).hasClass('fieldRib')) {
                        $(this).next('input').focus();
                    } else {
                        $(this).closest('.field-item').next().find('input').first().focus();
                    }
                }
            }
        });

        // Field integer only
        $('.integerOnly').on('keypress', function(event) {
            if (event.which != 8 && isNaN(String.fromCharCode(event.which))) {
                event.preventDefault(); //stop character from entering input
            }
        });

        $('.loader-offer').hide();
        $('.loader-iban').hide();
        $('.loader-validation').hide();


        /*=====================================
         =                BUTTON MODIFY BEHEVIOUR              =
         =====================================*/
        $('a[href="#step-2-ss-step-1"]').click(function() {
            $('.step-2-ss-step-2').removeClass('current completed').addClass('disabled');
            $('#step-2-ss-step-2').removeClass('show').attr('aria-expanded', false);
            $('.step-2-ss-step-3').removeClass('current completed').addClass('disabled');
            $('#step-2-ss-step-3').removeClass('show').attr('aria-expanded', false);
        });

        $('a[href="#step-2-ss-step-2"]').click(function() {
            $('.step-2-ss-step-3').removeClass('current completed').addClass('disabled');
            $('#step-2-ss-step-3').removeClass('show').attr('aria-expanded', false);
        });

        $('a[href="#step-3-ss-step-1"]').click(function() {
            $('.step-3-ss-step-2').removeClass('current completed').addClass('disabled');
            $('#step-3-ss-step-2').removeClass('show').attr('aria-expanded', false);
            $('.step-3-ss-step-3').removeClass('current completed').addClass('disabled');
            $('#step-3-ss-step-3').removeClass('show').attr('aria-expanded', false);
        });

        $('a[href="#step-3-ss-step-2"]').click(function() {
            $('.step-3-ss-step-3').removeClass('current completed').addClass('disabled');
            $('#step-3-ss-step-3').removeClass('show').attr('aria-expanded', false);
        });


        /*=====================================
         =                STEP1               =
         =====================================*/


        /* Fonction de calcul du prix en fonction des options et du code promo */
        function calculPrice() {
            if ($('#option-second-medaillon').is('.option-added')) {
                choice1 = true;
                $('*:hidden #second-contact-infos').removeClass('hidden-item');
                //console.log(choice1);
            } else {
                choice1 = false;
                $('*:hidden #second-contact-infos').addClass('hidden-item');
                //console.log(choice1);
            }
            if ($('#option-chute').is('.option-added')) {
                choice2 = true;
            } else {
                choice2 = false;
            }
            if ($('#option-fumee').is('.option-added')) {
                choice3 = true;
            } else {
                choice3 = false;
            }
            var codepromo = $('#code-promo').val();


            $('.loader-offer').show();
            $.ajax({
                url: '/souscription-step1promo',
                type: 'POST',
                data: {
                    'choice1': choice1,
                    'choice2': choice2,
                    'choice3': choice3,
                    'codepromo': codepromo
                },
                dataType: 'json',
                success: function(data, statut) {
                    if (data == null || data == false) {
                        document.location.href = "/500";
                    } else {
                        $('.loader-offer').hide();
                        if (data.discounts.length == 0 && $('#code-promo').val() != '') {
                            $('.codepromo-error .errors-list').html('<li>Ce code nâ€™est pas valide</li>');
                        } else if (data.discounts.length != 0 && data.discounts[0]) {
                            $('.promotion-recap .price', '.recap-cmde').html(data.discounts[0].name);
                            $('.promotion-recap', '.recap-cmde').removeClass('hidden-item');
                            $('.codepromo-error .errors-list').html('');
                        }
                        $('#offre-abonnement p.before span.amount').html($.number((data.totalWithTax), 2, ',', ' ') + " &euro;");
                        var reduction_impot = parseFloat($('#form-offre #reduction_impot').attr('data-value'));
                        $('#offre-abonnement p.after span.amount').html($.number((data.totalWithTax * reduction_impot), 2, ',', ' ') + " &euro;");
                        $('.recap-cmde .total .before .amount').html($.number((data.totalWithTax), 2, ',', ' ') + " &euro;");
                        $('.recap-cmde .total .after .amount').html($.number((data.totalWithTax * reduction_impot), 2, ',', ' ') + " &euro;");
                        $('#form-addr-rib .amount-total').html($.number((data.totalWithTax), 2, ',', ' ') + " &euro;");
                    }
                },

                error: function(resultat, statut, erreur) {
                    document.location.href = "/500";
                }

            });
        }


        function checkFirstCalculPrice() {
            if ($('#option-second-medaillon').is('.option-added') ||
                $('#option-chute').is('.option-added') ||
                $('#option-fumee').is('.option-added') ||
                $('#code-promo').val() != '') {
                return true;
            }
            return false;
        }

        if (checkFirstCalculPrice() == true) {
            calculPrice();
        }


        $('#form-offre input[type=checkbox]').click(function() {

            $(this).toggleClass('option-added');
            var option_id = $(this).attr('id');
            $('.list-cmde li[data-option="' + option_id + '"]').toggleClass('hidden-item');
            calculPrice();
        });

        $('.code-promo-container .btn-2').click(function(e) {
            e.preventDefault();
            calculPrice();
        });

        $('#form-offre').submit(function(e) {
            e.preventDefault();

            var choice1 = false;
            var choice2 = false;
            var choice3 = false;

            if ($('#option-second-medaillon').hasClass('option-added')) {
                choice1 = true;
            }
            if ($('#option-chute').hasClass('option-added')) {
                choice2 = true;
            }
            if ($('#option-fumee').hasClass('option-added')) {
                choice3 = true;
            }

            $.ajax({
                url: '/souscription-step1',
                type: 'POST',
                data: {
                    'choice1': choice1,
                    'choice2': choice2,
                    'choice3': choice3
                },
                dataType: 'json',
                success: function(data, statut) {
                    calculPrice();

                    // Timeline
                    $('#timeline-souscription #steps li[data-step="1"]').removeClass('current').addClass('completed');
                    $('#timeline-souscription #steps li[data-step="2"]').removeClass('disabled').addClass('current');

                    // Form
                    $('#step-1').removeClass('show').attr('aria-expanded', 'false');
                    $('#step-1').closest('.accordion-item').removeClass('current').addClass('completed');
                    $('#step-2').addClass('show').attr('aria-expanded', 'true');
                    $('#step-2').closest('.accordion-item').removeClass('disabled').addClass('current');
                    $('#step-2-ss-step-1').addClass('show').attr('aria-expanded', 'true');
                    $('#step-2-ss-step-1').closest('.accordion-item').removeClass('disabled').addClass('current');

                    $('.step-2-ss-step-2').removeClass('current completed').addClass('disabled');
                    $('.step-2-ss-step-2').find('.panel-collapse').removeClass('show').attr('aria-expanded', 'false');

                    $('.step-2-ss-step-3').removeClass('current completed').addClass('disabled');
                    $('.step-2-ss-step-3').find('.panel-collapse').removeClass('show').attr('aria-expanded', 'false');

                    var toTop = $('header').height() + $('.breadcrumb').height() + $('#timeline-souscription').height();
                    $('html, body').animate({ scrollTop: toTop }, 500).delay(250);

                    /*=====================================
                     =            TAGGAGE      =
                     =====================================*/
                    ga('send', 'pageview', '/souscription-en-ligne/souscripteur', '');
                },

                error: function(resultat, statut, erreur) {
                    document.location.href = "/500";
                }

            });
        });

        /*=====================================
         =           STEP2 COODONNEES        =
         =====================================*/

        function check_is_empty_error_subscriber(data) {
            if (data.hasOwnProperty('lastname') ||
                data.hasOwnProperty('firstname') ||
                data.hasOwnProperty('date') ||
                (data.hasOwnProperty('mail') && data.mail.length != 0) ||
                (data.hasOwnProperty('tel') && data.tel.length != 0) ||
                data.hasOwnProperty('CSRF')) {
                return false;
            }
            return true;
        }

        function remove_error_from_subscriber() {
            $('input[name=form\\[lastname\\]]', '#form-subscriber').removeClass('error-field');
            $('input[name=form\\[lastname\\]]', '#form-subscriber').parent().find('.errors-list').html('');

            $('input[name=form\\[firstname\\]]', '#form-subscriber').removeClass('error-field');
            $('input[name=form\\[firstname\\]]', '#form-subscriber').parent().find('.errors-list').html('');

            $('input[name=form\\[birthday\\]]', '#form-subscriber').removeClass('error-field');
            $('input[name=form\\[birthmonth\\]]', '#form-subscriber').removeClass('error-field');
            $('input[name=form\\[birthyear\\]]', '#form-subscriber').removeClass('error-field');
            $('input[name=form\\[birthday\\]]', '#form-subscriber').parent().find('.errors-list').html('');

            $('input[name=form\\[tel\\]]', '#form-subscriber').removeClass('error-field');
            $('input[name=form\\[tel\\]]', '#form-subscriber').parent().find('.errors-list').html('');

            $('input[name=form\\[mail\\]]', '#form-subscriber').removeClass('error-field');
            $('input[name=form\\[mail\\]]', '#form-subscriber').parent().find('.errors-list').html('');
        }

        $("#form-subscriber").keyup(function(e) {
            var target = $(e.target).attr("id");
            if (target == 'form_birthday_subs' || target == 'form_birthmonth_subs' || target == 'form_birthyear_subs') {
                $('input[name=form\\[birthday\\]]', '#form-subscriber').removeClass('error-field');
                $('input[name=form\\[birthmonth\\]]', '#form-subscriber').removeClass('error-field');
                $('input[name=form\\[birthyear\\]]', '#form-subscriber').removeClass('error-field');
                $('input[name=form\\[birthday\\]]', '#form-subscriber').parent().find('.errors-list').html('');
            } else {
                if ($('#' + target, '#form-subscriber').hasClass('error-field')) {
                    $('#' + target, '#form-subscriber').removeClass('error-field');
                    $('#' + target, '#form-subscriber').parent().find('.errors-list').html('');
                }
            }
        });


        $('#form-subscriber').submit(function(e) {
            e.preventDefault();
            var civilite = ($('input[name=form\\[sex\\]]:checked', '#form-subscriber').val());
            var lastname = $('input[name=form\\[lastname\\]]', '#form-subscriber').val();
            var firstname = $('input[name=form\\[firstname\\]]', '#form-subscriber').val();
            var birthday = $('input[name=form\\[birthday\\]]', '#form-subscriber').val();
            var birthmonth = $('input[name=form\\[birthmonth\\]]', '#form-subscriber').val();
            var birthyear = $('input[name=form\\[birthyear\\]]', '#form-subscriber').val();
            var email = $('input[name=form\\[mail\\]]', '#form-subscriber').val();
            var emailConfirm = $('input[name=form\\[mailConfirm\\]]', '#form-subscriber').val();
            var dataToCom = $('input[name=form\\[dataToCom\\]]:checked', '#form-subscriber').val();
            var dataToPart = $('input[name=form\\[dataToPart\\]]:checked', '#form-subscriber').val();
            var phone = $('input[name=form\\[tel\\]]', '#form-subscriber').val();
            var token = $('input[name=form\\[_token\\]]', '#form-subscriber').val();

            $('.email-soucriber').html(email);

            $.ajax({
                url: '/souscription-step2-subscriber',
                type: 'POST',
                data: {
                    'form[sex]': civilite,
                    'form[lastname]': lastname,
                    'form[firstname]': firstname,
                    'form[birthday]': birthday,
                    'form[birthmonth]': birthmonth,
                    'form[birthyear]': birthyear,
                    'form[tel]': phone,
                    'form[mail]': email,
                    'form[mailConfirm]': emailConfirm,
                    'form[dataToCom]': dataToCom,
                    'form[dataToPart]': dataToPart,
                    'form[_token]': token
                },
                dataType: 'json',
                success: function(data, statut) {
                    remove_error_from_subscriber();
                    if (check_is_empty_error_subscriber(data)) {
                        $('#step-2-ss-step-1').removeClass('show').attr('aria-expanded', 'false');
                        $('#step-2-ss-step-1').closest('.accordion-item').removeClass('current').addClass('completed');
                        $('#step-2-ss-step-2').addClass('show').attr('aria-expanded', 'true');
                        $('#step-2-ss-step-2').closest('.accordion-item').removeClass('disabled').addClass('current');

                        var toTop = $('header').height() + $('.breadcrumb').height() + $('#timeline-souscription').height();

                        $('html, body').animate({ scrollTop: toTop }, 500).delay(250);

                        var lastname = $('input[name=form\\[lastname\\]]', '#form-subscriber').val();
                        var firstname = $('input[name=form\\[firstname\\]]', '#form-subscriber').val();
                        var phone = $('input[name=form\\[tel\\]]', '#form-subscriber').val();
                        if (phone[1] != '6' && phone[1] != 7)
                            subcriber_tel_fixe = true;
                        else
                            subcriber_tel_fixe = false;

                        var subsIsBenef = ($('input[name=form\\[subsIsBenef\\]]:checked', '#form-benefit').val());
                        if (subsIsBenef == true) {
                            if (subcriber_tel_fixe == true) {
                                $('#form_tel_benefit').parent().parent().hide();
                            } else {
                                $('#form_tel_benefit').parent().parent().show();
                            }
                        }


                        var email = $('input[name=form\\[mail\\]]', '#form-subscriber').val();

                        $('#form-contact .checkName .name span').html(firstname + ' ' + lastname);
                        $('#form-contact .checkTel span').html(phone);
                        $('.recap-subscriber .recap p.name').html(firstname + ' ' + lastname);
                        $('.recap-subscriber .recap p.recapmail').html('E-mail : ' + email);
                        $('.recap-subscriber .recap p.recaptel').html('Téléphone : ' + phone);

                    } else {
                        if (data.hasOwnProperty('CSRF')) {
                            $('#popup-page-expired').css('display', 'flex');
                        }
                        if (data.hasOwnProperty('lastname')) {
                            $('input[name=form\\[lastname\\]]', '#form-subscriber').addClass('error-field');
                            var text = '<li>' + data.lastname + '</li>';
                            $('input[name=form\\[lastname\\]]', '#form-subscriber').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('firstname')) {
                            $('input[name=form\\[firstname\\]]', '#form-subscriber').addClass('error-field');
                            var text = '<li>' + data.firstname + '</li>';
                            $('input[name=form\\[firstname\\]]', '#form-subscriber').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('date')) {
                            $('input[name=form\\[birthday\\]]', '#form-subscriber').addClass('error-field');
                            $('input[name=form\\[birthmonth\\]]', '#form-subscriber').addClass('error-field');
                            $('input[name=form\\[birthyear\\]]', '#form-subscriber').addClass('error-field');
                            var text = '<li>' + data.date + '</li>';
                            $('input[name=form\\[birthday\\]]', '#form-subscriber').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('mail') && data.mail.length != 0) {
                            $('input[name=form\\[mail\\]]', '#form-subscriber').addClass('error-field');
                            var text = '';
                            var i = 0;
                            while (i < data.mail.length) {
                                text += '<li>' + data.mail[i] + '</li>';
                                ++i;
                            }
                            $('input[name=form\\[mail\\]]', '#form-subscriber').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('tel') && data.tel.length != 0) {
                            $('input[name=form\\[tel\\]]', '#form-subscriber').addClass('error-field');
                            var text = '';
                            var i = 0;
                            while (i < data.tel.length) {
                                text += '<li>' + data.tel[i] + '</li>';
                                ++i;
                            }
                            $('input[name=form\\[tel\\]]', '#form-subscriber').parent().find('.errors-list').html(text);
                        }

                    }

                    /*=====================================
                     =            TAGGAGE      =
                     =====================================*/
                    ga('send', 'pageview', '/souscription-en-ligne/beneficiaire', '');

                },

                error: function(resultat, statut, erreur) {
                    document.location.href = "/500";
                }

            });
        });



        $('input[name=form\\[addressPostal\\]]', '#form-addr-rib').keyup(function() {
            if ($(this).val().length == 5) {
                var cp = $(this).val();
                $.ajax({
                    url: '/souscription-getcitybycp',
                    type: 'POST',
                    data: {
                        'cp': cp
                    },
                    dataType: 'json',
                    success: function(data, statut) {
                        if (data != false) {
                            $('#form_addressCity', '#form-addr-rib').autocomplete({
                                source: data
                            });
                        }
                    },

                    error: function(resultat, statut, erreur) {
                        document.location.href = "/500";
                    }

                });
            }
        });

        /***** BENEFICIAIRE *****/

        $('input[name=form\\[addressPostal\\]]', '#form-benefit').keyup(function() {
            if ($(this).val().length == 5) {
                var cp = $(this).val();
                $.ajax({
                    url: '/souscription-getcitybycp',
                    type: 'POST',
                    data: {
                        'cp': cp
                    },
                    dataType: 'json',
                    success: function(data, statut) {
                        if (data != false) {
                            $('#form_addressCity_benefit', '#form-benefit').autocomplete({
                                source: data
                            });
                        }
                    },

                    error: function(resultat, statut, erreur) {
                        document.location.href = "/500";
                    }

                });
            }
        });

        function check_is_empty_error_beneficiaire(data) {
            if (data.hasOwnProperty('lastname') ||
                data.hasOwnProperty('firstname') ||
                data.hasOwnProperty('date') ||
                data.hasOwnProperty('addressCity') ||
                data.hasOwnProperty('addressPostal') ||
                data.hasOwnProperty('addressName') ||
                data.hasOwnProperty('second_lastname') ||
                data.hasOwnProperty('second_firstname') ||
                data.hasOwnProperty('second_date') ||
                (data.hasOwnProperty('tel') && data.tel.length != 0) ||
                data.hasOwnProperty('CSRF')) {
                return false;
            }
            return true;
        }

        function remove_error_from_beneficiaire() {
            var subsIsBenef = ($('input[name=form\\[subsIsBenef\\]]:checked', '#form-benefit').val());
            var secondmedaillon = false;
            if ($('#option-second-medaillon').hasClass('option-added')) {
                secondmedaillon = true;
            }
            if (subsIsBenef == false) {
                $('input[name=form\\[lastname\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[lastname\\]]', '#form-benefit').parent().find('.errors-list').html('');

                $('input[name=form\\[firstname\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[firstname\\]]', '#form-benefit').parent().find('.errors-list').html('');

                $('input[name=form\\[birthday\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[birthmonth\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[birthyear\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[birthday\\]]', '#form-benefit').parent().find('.errors-list').html('');

                $('input[name=form\\[tel\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[tel\\]]', '#form-benefit').parent().find('.errors-list').html('');
                $('input[name=form\\[tel\\]]', '#form-subscriber').removeClass('error-field');
            } else if (subcriber_tel_fixe == true) {
                $('input[name=form\\[tel\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[tel\\]]', '#form-benefit').parent().find('.errors-list').html('');
                $('input[name=form\\[tel\\]]', '#form-subscriber').removeClass('error-field');
            }

            if (secondmedaillon == true) {
                $('input[name=form\\[second_lastname\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[second_lastname\\]]', '#form-benefit').parent().find('.errors-list').html('');

                $('input[name=form\\[second_firstname\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[second_firstname\\]]', '#form-benefit').parent().find('.errors-list').html('');

                $('input[name=form\\[second_birthday\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[second_birthmonth\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[second_birthyear\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[second_birthday\\]]', '#form-benefit').parent().find('.errors-list').html('');
            }

            $('input[name=form\\[addressCity\\]]', '#form-benefit').removeClass('error-field');
            $('input[name=form\\[addressCity\\]]', '#form-benefit').parent().find('.errors-list').html('');

            $('input[name=form\\[addressPostal\\]]', '#form-benefit').removeClass('error-field');
            $('input[name=form\\[addressPostal\\]]', '#form-benefit').parent().find('.errors-list').html('');

            $('input[name=form\\[addressName\\]]', '#form-benefit').removeClass('error-field');
            $('input[name=form\\[addressName\\]]', '#form-benefit').parent().find('.errors-list').html('');

            $('input[name=form\\[addressMore\\]]', '#form-benefit').removeClass('error-field');
            $('input[name=form\\[addressMore\\]]', '#form-benefit').parent().find('.errors-list').html('');
        }

        $("#form-benefit").keyup(function(e) {
            var target = $(e.target).attr("id");
            if (target == 'form_birthday_benefit' || target == 'form_birthmonth_benefit' || target == 'form_birthyear_benefit') {
                $('input[name=form\\[birthday\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[birthmonth\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[birthyear\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[birthday\\]]', '#form-benefit').parent().find('.errors-list').html('');
            } else if (target == 'form_birthday_second_benefit' || target == 'form_birthmonth_second_benefit' || target == 'form_birthyear_second_benefit') {
                $('input[name=form\\[second_birthday\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[second_birthmonth\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[second_birthyear\\]]', '#form-benefit').removeClass('error-field');
                $('input[name=form\\[second_birthday\\]]', '#form-benefit').parent().find('.errors-list').html('');
            } else {
                if ($('#' + target, '#form-benefit').hasClass('error-field')) {
                    $('#' + target, '#form-benefit').removeClass('error-field');
                    $('#' + target, '#form-benefit').parent().find('.errors-list').html('');
                }
            }
        });

        $('#form-benefit').submit(function(e) {
            e.preventDefault();
            var secondmedaillon = false;
            if ($('#option-second-medaillon').hasClass('option-added')) {
                secondmedaillon = true;
            }
            if (secondmedaillon == true) {
                var second_benef_sex = ($('input[name=form\\[second_benef_sex\\]]:checked', '#form-benefit').val());
                var second_lastname = $('input[name=form\\[second_lastname\\]]', '#form-benefit').val();
                var second_firstname = $('input[name=form\\[second_firstname\\]]', '#form-benefit').val();
                var second_birthday = $('input[name=form\\[second_birthday\\]]', '#form-benefit').val();
                var second_birthmonth = $('input[name=form\\[second_birthmonth\\]]', '#form-benefit').val();
                var second_birthyear = $('input[name=form\\[second_birthyear\\]]', '#form-benefit').val();
            } else {
                var second_benef_sex = '';
                var second_lastname = '';
                var second_firstname = '';
                var second_birthday = '';
                var second_birthmonth = '';
                var second_birthyear = '';
            }

            subsIsBenef = ($('input[name=form\\[subsIsBenef\\]]:checked', '#form-benefit').val());
            if (subsIsBenef == true) {
                var civilite = '';
                var lastname = '';
                var firstname = '';
                var birthday = '';
                var birthmonth = '';
                var birthyear = '';
                $('#form-contact .boolForm').hide();
                $('#form-contact .innerForm').show();
                $('#form-contact .checkForm').hide();
                $('#form_subsIsContact #form_subsIsContact_1').prop('checked', true);

                if (subcriber_tel_fixe == true) {
                    var phone = '';
                } else {
                    var phone = $('input[name=form\\[tel\\]]', '#form-benefit').val();
                }

            } else {
                $('#form-contact .boolForm').show();
                $('#form_subsIsContact #form_subsIsContact_1').prop('checked', true);
                $('#form-contact .innerForm').show();
                $('#form-contact .checkForm').hide();
                var civilite = ($('input[name=form\\[benef_sex\\]]:checked', '#form-benefit').val());
                var lastname = $('input[name=form\\[lastname\\]]', '#form-benefit').val();
                var firstname = $('input[name=form\\[firstname\\]]', '#form-benefit').val();
                var birthday = $('input[name=form\\[birthday\\]]', '#form-benefit').val();
                var birthmonth = $('input[name=form\\[birthmonth\\]]', '#form-benefit').val();
                var birthyear = $('input[name=form\\[birthyear\\]]', '#form-benefit').val();
                var phone = $('input[name=form\\[tel\\]]', '#form-benefit').val();
            }

            var addressNum = $('input[name=form\\[addressNum\\]]', '#form-benefit').val();
            var addressName = $('input[name=form\\[addressName\\]]', '#form-benefit').val();
            var addressMore = $('input[name=form\\[addressMore\\]]', '#form-benefit').val();
            var addressPostal = $('input[name=form\\[addressPostal\\]]', '#form-benefit').val();
            var addressCity = $('input[name=form\\[addressCity\\]]', '#form-benefit').val();
            var token = $('input[name=form\\[_token\\]]', '#form-benefit').val();
            $.ajax({
                url: '/souscription-step2-beneficiaire',
                type: 'POST',
                data: {
                    'form[subsIsBenef]': subsIsBenef,
                    'form[benef_sex]': civilite,
                    'form[lastname]': lastname,
                    'form[firstname]': firstname,
                    'form[birthday]': birthday,
                    'form[birthmonth]': birthmonth,
                    'form[birthyear]': birthyear,
                    'form[tel]': phone,
                    'form[addressNum]': addressNum,
                    'form[addressName]': addressName,
                    'form[addressMore]': addressMore,
                    'form[addressPostal]': addressPostal,
                    'form[addressCity]': addressCity,
                    'form[second_benef_sex]': second_benef_sex,
                    'form[second_lastname]': second_lastname,
                    'form[second_firstname]': second_firstname,
                    'form[second_birthday]': second_birthday,
                    'form[second_birthmonth]': second_birthmonth,
                    'form[second_birthyear]': second_birthyear,
                    'secondmedaillon': secondmedaillon,
                    'form[_token]': token
                },
                dataType: 'json',
                success: function(data, statut) {
                    remove_error_from_beneficiaire();
                    if (check_is_empty_error_beneficiaire(data)) {
                        $('#step-2-ss-step-2').removeClass('show').attr('aria-expanded', 'false');
                        $('#step-2-ss-step-2').closest('.accordion-item').removeClass('current').addClass('completed');
                        $('#step-2-ss-step-3').addClass('show').attr('aria-expanded', 'true');
                        $('#step-2-ss-step-3').closest('.accordion-item').removeClass('disabled').addClass('current');

                        var toTop = $('header').height() + $('.breadcrumb').height() + $('#timeline-souscription').height();
                        $('html, body').animate({ scrollTop: toTop }, 500).delay(250);

                        if (subsIsBenef == true) {
                            $('#form_addressNum', '#form-addr-rib').val(addressNum);
                            $('#form_addressName', '#form-addr-rib').val(addressName);
                            $('#form_addressMore', '#form-addr-rib').val(addressMore);
                            $('#form_addressPostal', '#form-addr-rib').val(addressPostal);
                            $('#form_addressCity', '#form-addr-rib').val(addressCity);
                        }
                    } else {
                        if (data.hasOwnProperty('CSRF')) {
                            $('#popup-page-expired').css('display', 'flex');
                        }
                        if (data.hasOwnProperty('lastname')) {
                            $('input[name=form\\[lastname\\]]', '#form-benefit').addClass('error-field');
                            var text = '<li>' + data.lastname + '</li>';
                            $('input[name=form\\[lastname\\]]', '#form-benefit').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('firstname')) {
                            $('input[name=form\\[firstname\\]]', '#form-benefit').addClass('error-field');
                            var text = '<li>' + data.firstname + '</li>';
                            $('input[name=form\\[firstname\\]]', '#form-benefit').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('addressCity')) {
                            $('input[name=form\\[addressCity\\]]', '#form-benefit').addClass('error-field');
                            var text = '<li>' + data.addressCity + '</li>';
                            $('input[name=form\\[addressCity\\]]', '#form-benefit').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('addressPostal')) {
                            $('input[name=form\\[addressPostal\\]]', '#form-benefit').addClass('error-field');
                            var text = '<li>' + data.addressPostal + '</li>';
                            $('input[name=form\\[addressPostal\\]]', '#form-benefit').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('addressName')) {
                            $('input[name=form\\[addressName\\]]', '#form-benefit').addClass('error-field');
                            var text = '<li>' + data.addressName + '</li>';
                            $('input[name=form\\[addressName\\]]', '#form-benefit').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('addressMore')) {
                            $('input[name=form\\[addressMore\\]]', '#form-benefit').addClass('error-field');
                            var text = '<li>' + data.addressMore + '</li>';
                            $('input[name=form\\[addressMore\\]]', '#form-benefit').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('date')) {
                            $('input[name=form\\[birthday\\]]', '#form-benefit').addClass('error-field');
                            $('input[name=form\\[birthmonth\\]]', '#form-benefit').addClass('error-field');
                            $('input[name=form\\[birthyear\\]]', '#form-benefit').addClass('error-field');
                            var text = '<li>' + data.date + '</li>';
                            $('input[name=form\\[birthday\\]]', '#form-benefit').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('second_lastname')) {
                            $('input[name=form\\[second_lastname\\]]', '#form-benefit').addClass('error-field');
                            var text = '<li>' + data.second_lastname + '</li>';
                            $('input[name=form\\[second_lastname\\]]', '#form-benefit').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('second_firstname')) {
                            $('input[name=form\\[second_firstname\\]]', '#form-benefit').addClass('error-field');
                            var text = '<li>' + data.second_firstname + '</li>';
                            $('input[name=form\\[second_firstname\\]]', '#form-benefit').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('second_date')) {
                            $('input[name=form\\[second_birthday\\]]', '#form-benefit').addClass('error-field');
                            $('input[name=form\\[second_birthmonth\\]]', '#form-benefit').addClass('error-field');
                            $('input[name=form\\[second_birthyear\\]]', '#form-benefit').addClass('error-field');
                            var text = '<li>' + data.second_date + '</li>';
                            $('input[name=form\\[second_birthday\\]]', '#form-benefit').parent().find('.errors-list').html(text);
                        }
                        if (data.tel.length != 0) {
                            $('input[name=form\\[tel\\]]', '#form-benefit').addClass('error-field');
                            var text = '';
                            var i = 0;
                            while (i < data.tel.length) {
                                text += '<li>' + data.tel[i] + '</li>';
                                ++i;
                            }
                            $('input[name=form\\[tel\\]]', '#form-benefit').parent().find('.errors-list').html(text);
                        }

                    }

                    /*=====================================
                     =            TAGGAGE      =
                     =====================================*/
                    ga('send', 'pageview', '/souscription-en-ligne/contact', '');
                },

                error: function(resultat, statut, erreur) {
                    document.location.href = "/500";
                }

            });
        });

        // Btn add second tel
        $('#btn-add-second-tel').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('hidden-item');
            $('.second-tel-subsiscontact').toggleClass('hidden-item');
            $.ajax({
                url: '/souscription-step2-contacts-addphone',
                type: 'POST',
                data: {},
                dataType: 'json',
                success: function(data, statut) {

                },
                error: function(resultat, statut, erreur) {
                    document.location.href = "/500";
                }
            });
        });

        // Display form contact nÂ°2
        $('.add-elt').click(function(e) {
            e.preventDefault();
            var target = $(this).attr('href');
            if ($(this).hasClass('add-contact')) {
                $(this).hide();
            }
            displayElt(target);
            $.ajax({
                url: '/souscription-step2-contacts-addcontact',
                type: 'POST',
                data: {},
                dataType: 'json',
                success: function(data, statut) {

                },
                error: function(resultat, statut, erreur) {
                    document.location.href = "/500";
                }
            });
        });

        // Hide form contact nÂ°2
        $('.delete-elt').click(function(e) {
            e.preventDefault();
            var target = $(this).attr('href');
            if ($(this).hasClass('delete-contact')) {
                $('.add-contact').show();
            }
            hideElt(target);
            $.ajax({
                url: '/souscription-step2-contacts-deletecontact',
                type: 'POST',
                data: {},
                dataType: 'json',
                success: function(data, statut) {

                },
                error: function(resultat, statut, erreur) {
                    document.location.href = "/500";
                }
            });
        });

        function check_is_empty_error_contact(data) {
            if (data.hasOwnProperty('firstname') ||
                data.hasOwnProperty('firstname_2') ||
                data.hasOwnProperty('lastname') ||
                data.hasOwnProperty('lastname_2') ||
                (data.hasOwnProperty('telone') && data.telone.length != 0) ||
                (data.hasOwnProperty('telone_2') && data.telone_2.length != 0) ||
                (data.hasOwnProperty('teltwo') && data.teltwo.length != 0) ||
                (data.hasOwnProperty('teltwo_2') && data.teltwo_2.length != 0) ||
                (data.hasOwnProperty('teltwo_subsiscontact') && data.teltwo_subsiscontact.length != 0) ||
                data.hasOwnProperty('CSRF')) {
                return false;
            }
            return true;
        }

        function remove_error_from_contact() {
            var text = '';
            $('input[name=form\\[teltwo_subsiscontact\\]]', '#form-contact').removeClass('error-field');
            $('input[name=form\\[teltwo_subsiscontact\\]]', '#form-contact').parent().find('.errors-list').html(text);
            $('input[name=form\\[lastname\\]]', '#form-contact').removeClass('error-field');
            $('input[name=form\\[lastname\\]]', '#form-contact').parent().parent().find('.errors-list').html(text);
            $('input[name=form\\[firstname\\]]', '#form-contact').removeClass('error-field');
            $('input[name=form\\[firstname\\]]', '#form-contact').parent().parent().find('.errors-list').html(text);
            $('input[name=form\\[lastname_2\\]]', '#form-contact').removeClass('error-field');
            $('input[name=form\\[lastname_2\\]]', '#form-contact').parent().parent().find('.errors-list').html(text);
            $('input[name=form\\[firstname_2\\]]', '#form-contact').removeClass('error-field');
            $('input[name=form\\[firstname_2\\]]', '#form-contact').parent().parent().find('.errors-list').html(text);
            $('input[name=form\\[telone\\]]', '#form-contact').removeClass('error-field');
            $('input[name=form\\[telone\\]]', '#form-contact').parent().find('.errors-list').html(text);
            $('input[name=form\\[telone_2\\]]', '#form-contact').removeClass('error-field');
            $('input[name=form\\[telone_2\\]]', '#form-contact').parent().find('.errors-list').html(text);
            $('input[name=form\\[teltwo\\]]', '#form-contact').removeClass('error-field');
            $('input[name=form\\[teltwo\\]]', '#form-contact').parent().find('.errors-list').html(text);
            $('input[name=form\\[teltwo_2\\]]', '#form-contact').removeClass('error-field');
            $('input[name=form\\[teltwo_2\\]]', '#form-contact').parent().find('.errors-list').html(text);
            $('input[name=form\\[teltwo_subsiscontact\\]]', '#form-contact').removeClass('error-field');
            $('input[name=form\\[teltwo_subsiscontact\\]]', '#form-contact').parent().find('.errors-list').html(text);
        }

        $("#form-contact").keyup(function(e) {
            var target = $(e.target).attr("id");
            if ($('#' + target, '#form-contact').hasClass('error-field')) {
                $('#' + target, '#form-contact').removeClass('error-field');
                $('#' + target, '#form-contact').parent().find('.errors-list').html('');
            }
        });

        $('#form-contact').submit(function(e) {
            e.preventDefault();
            subsIsContact = ($('input[name=form\\[subsIsContact\\]]:checked', '#form-contact').val());

            var contact_sex = ($('input[name=form\\[contact_sex\\]]:checked', '#form-contact').val());
            var lastname = ($('input[name=form\\[lastname\\]]', '#form-contact').val());
            var firstname = ($('input[name=form\\[firstname\\]]', '#form-contact').val());
            var telone = ($('input[name=form\\[telone\\]]', '#form-contact').val());
            var teltwo = ($('input[name=form\\[teltwo\\]]', '#form-contact').val());
            var teltwo_subsiscontact = null;
            if (subsIsContact == true) {
                var teltwo_subsiscontact = ($('input[name=form\\[teltwo_subsiscontact\\]]', '#form-contact').val());
            }
            var contact_sex_2 = ($('input[name=form\\[contact_sex_2\\]]:checked', '#form-contact').val());
            var lastname_2 = ($('input[name=form\\[lastname_2\\]]', '#form-contact').val());
            var firstname_2 = ($('input[name=form\\[firstname_2\\]]', '#form-contact').val());
            var telone_2 = ($('input[name=form\\[telone_2\\]]', '#form-contact').val());
            var teltwo_2 = ($('input[name=form\\[teltwo_2\\]]', '#form-contact').val());
            var token = $('input[name=form\\[_token\\]]', '#form-contact').val();

            if (contact_sex_2 != '' && lastname_2 != '' && firstname_2 != '') {
                secondContact = true;
            }
            $.ajax({
                url: '/souscription-step2-contacts',
                type: 'POST',
                data: {
                    'form[subsIsContact]': subsIsContact,
                    'form[contact_sex]': contact_sex,
                    'form[lastname]': lastname,
                    'form[firstname]': firstname,
                    'form[telone]': telone,
                    'form[teltwo]': teltwo,
                    'form[teltwo_subsiscontact]': teltwo_subsiscontact,
                    'form[contact_sex_2]': contact_sex_2,
                    'form[lastname_2]': lastname_2,
                    'form[firstname_2]': firstname_2,
                    'form[telone_2]': telone_2,
                    'form[teltwo_2]': teltwo_2,
                    'form[_token]': token
                },
                dataType: 'json',
                success: function(data, statut) {
                    remove_error_from_contact();
                    if (check_is_empty_error_contact(data)) {
                        // Timeline
                        $('#timeline-souscription #steps li[data-step="2"]').removeClass('current').addClass('completed');
                        $('#timeline-souscription #steps li[data-step="3"]').removeClass('disabled').addClass('current');

                        // Form
                        $('#step-3').addClass('show').attr('aria-expanded', 'true');
                        $('#step-3').closest('.accordion-item').removeClass('disabled').addClass('current');
                        $('#step-3-ss-step-1').addClass('show').attr('aria-expanded', 'true');
                        $('#step-3-ss-step-1').closest('.accordion-item').removeClass('disabled').addClass('current');
                        $('#step-2-ss-step-3').removeClass('show').attr('aria-expanded', 'false');
                        $('#step-2-ss-step-3').closest('.accordion-item').removeClass('current').addClass('completed');
                        $('#heading-step-2').removeClass('show').attr('aria-expanded', 'false');
                        $('#heading-step-2').closest('.accordion-item').removeClass('current').addClass('completed');
                        $('#step-2').removeClass('show').attr('aria-expanded', 'false');
                        $('#step-2').closest('.accordion-item').removeClass('current').addClass('completed');

                        $('.step-3-ss-step-2').removeClass('current completed').addClass('disabled');
                        $('.step-3-ss-step-2').find('.panel-collapse').removeClass('show').attr('aria-expanded', 'false');

                        $('.step-3-ss-step-3').removeClass('current completed').addClass('disabled');
                        $('.step-3-ss-step-3').find('.panel-collapse').removeClass('show').attr('aria-expanded', 'false');

                        var toTop = $('header').height() + $('.breadcrumb').height() + $('#timeline-souscription').height();
                        $('html, body').animate({ scrollTop: toTop }, 500).delay(250);
                    } else {
                        if (data.hasOwnProperty('CSRF')) {
                            $('#popup-page-expired').css('display', 'flex');
                        }
                        if (data.hasOwnProperty('teltwo_subsiscontact')) {
                            $('input[name=form\\[teltwo_subsiscontact\\]]', '#form-contact').addClass('error-field');
                            var text = '<li>' + data.teltwo_subsiscontact + '</li>';
                            $('input[name=form\\[teltwo_subsiscontact\\]]', '#form-contact').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('lastname')) {
                            $('input[name=form\\[lastname\\]]', '#form-contact').addClass('error-field');
                            var text = '<li>' + data.lastname + '</li>';
                            $('input[name=form\\[lastname\\]]', '#form-contact').parent().parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('firstname')) {
                            $('input[name=form\\[firstname\\]]', '#form-contact').addClass('error-field');
                            var text = '<li>' + data.firstname + '</li>';
                            $('input[name=form\\[firstname\\]]', '#form-contact').parent().parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('lastname_2')) {
                            $('input[name=form\\[lastname_2\\]]', '#form-contact').addClass('error-field');
                            var text = '<li>' + data.lastname_2 + '</li>';
                            $('input[name=form\\[lastname_2\\]]', '#form-contact').parent().parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('firstname_2')) {
                            $('input[name=form\\[firstname_2\\]]', '#form-contact').addClass('error-field');
                            var text = '<li>' + data.firstname_2 + '</li>';
                            $('input[name=form\\[firstname_2\\]]', '#form-contact').parent().parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('telone') && data.telone.length != 0) {
                            $('input[name=form\\[telone\\]]', '#form-contact').addClass('error-field');
                            var text = '';
                            var i = 0;
                            while (i < data.telone.length) {
                                text += '<li>' + data.telone[i] + '</li>';
                                ++i;
                            }
                            $('input[name=form\\[telone\\]]', '#form-contact').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('telone_2') && data.telone_2.length != 0) {
                            $('input[name=form\\[telone_2\\]]', '#form-contact').addClass('error-field');
                            var text = '';
                            var i = 0;
                            while (i < data.telone_2.length) {
                                text += '<li>' + data.telone_2[i] + '</li>';
                                ++i;
                            }
                            $('input[name=form\\[telone_2\\]]', '#form-contact').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('teltwo') && data.teltwo.length != 0) {
                            $('input[name=form\\[teltwo\\]]', '#form-contact').addClass('error-field');
                            var text = '';
                            var i = 0;
                            while (i < data.teltwo.length) {
                                text += '<li>' + data.teltwo[i] + '</li>';
                                ++i;
                            }
                            $('input[name=form\\[teltwo\\]]', '#form-contact').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('teltwo_2') && data.teltwo_2.length != 0) {
                            $('input[name=form\\[teltwo_2\\]]', '#form-contact').addClass('error-field');
                            var text = '';
                            var i = 0;
                            while (i < data.teltwo_2.length) {
                                text += '<li>' + data.teltwo_2[i] + '</li>';
                                ++i;
                            }
                            $('input[name=form\\[teltwo_2\\]]', '#form-contact').parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('teltwo_subsiscontact') && data.teltwo_subsiscontact.length != 0) {
                            $('input[name=form\\[teltwo_subsiscontact\\]]', '#form-contact').addClass('error-field');
                            var text = '';
                            var i = 0;
                            while (i < data.teltwo_subsiscontact.length) {
                                text += '<li>' + data.teltwo_subsiscontact[i] + '</li>';
                                ++i;
                            }
                            $('input[name=form\\[teltwo_subsiscontact\\]]', '#form-contact').parent().find('.errors-list').html(text);
                        }

                    }

                    /*=====================================
                     =            TAGGAGE      =
                     =====================================*/
                    ga('send', 'pageview', '/souscription-en-ligne/recapitulatif', '');
                },

                error: function(resultat, statut, erreur) {
                    document.location.href = "/500";
                }

            });
        });

        $('.step-3-ss-step-1 .btn-main').click(function(e) {
            e.preventDefault();
            $('#step-3-ss-step-2').addClass('show').attr('aria-expanded', 'true');
            $('#step-3-ss-step-2').closest('.accordion-item').removeClass('disabled').addClass('current');
            $('#step-3-ss-step-1').removeClass('show').attr('aria-expanded', 'false');
            $('#step-3-ss-step-1').closest('.accordion-item').removeClass('current').addClass('completed');

            var toTop = $('header').height() + $('.breadcrumb').height() + $('#timeline-souscription').height();
            $('html, body').animate({ scrollTop: toTop }, 500).delay(250);

            /*=====================================
             =            TAGGAGE      =
             =====================================*/
            ga('send', 'pageview', '/souscription-en-ligne/rib', '');
        });


        function checkRibAndGenerateIban() {
            var code_banque = $('#form_code_banque').val();
            var code_guichet = $('#form_code_guichet').val();
            var numero_de_compte = $('#form_numero_de_compte').val();
            var cle_rib = $('#form_cle_rib').val();



            if (code_banque.length == 5 &&
                code_guichet.length == 5 &&
                numero_de_compte.length == 11 &&
                cle_rib.length == 2) {
                $('.loader-iban').show();
                $.ajax({
                    url: '/souscription-generate-iban',
                    type: 'POST',
                    data: {
                        'code_banque': code_banque,
                        'code_guichet': code_guichet,
                        'numero_de_compte': numero_de_compte,
                        'cle_rib': cle_rib
                    },
                    dataType: 'json',
                    success: function(data, statut) {
                        if (data != 'error') {
                            $('#form_iban').val(data);
                        }
                        $('.loader-iban').hide();
                    },

                    error: function(resultat, statut, erreur) {
                        document.location.href = "/500";
                    }

                });

            }
        }

        $('#form_code_banque').keyup(function() {
            checkRibAndGenerateIban();
        });
        $('#form_code_guichet').keyup(function() {
            checkRibAndGenerateIban();
        });
        $('#form_numero_de_compte').keyup(function() {
            checkRibAndGenerateIban();
        });
        $('#form_cle_rib').keyup(function() {
            checkRibAndGenerateIban();
        });

        function remove_error_from_rib() {
            $('input[name=form\\[code_banque\\]]', '#form-rib').removeClass('error-field');
            $('input[name=form\\[code_guichet\\]]', '#form-rib').removeClass('error-field');
            $('input[name=form\\[numero_de_compte\\]]', '#form-rib').removeClass('error-field');
            $('input[name=form\\[cle_rib\\]]', '#form-rib').removeClass('error-field');
            $('.codes-rib', '#form-rib').parent().find('.errors-list').html('');
            $('input[name=form\\[iban\\]]', '#form-rib').removeClass('error-field');
            $('input[name=form\\[iban\\]]', '#form-rib').parent().parent().find('.errors-list').html('');
            $('input[name=form\\[bic\\]]', '#form-rib').removeClass('error-field');
            $('input[name=form\\[bic\\]]', '#form-rib').parent().parent().find('.errors-list').html('');
            $('input[name=form\\[bank_name\\]]', '#form-rib').removeClass('error-field');
            $('input[name=form\\[bank_name\\]]', '#form-rib').parent().parent().find('.errors-list').html('');
        }

        $("#form-rib").keyup(function(e) {
            var target = $(e.target).attr("id");
            if ($('#' + target, '#form-rib').hasClass('error-field')) {
                $('#' + target, '#form-rib').removeClass('error-field');
                $('#' + target, '#form-rib').parent().find('.errors-list').html('');
            }
        });

        var bank_name_is_show = false;

        $('#form-rib').submit(function(e) {
            e.preventDefault();
            var bic = ($('input[name=form\\[bic\\]]', '#form-rib').val());
            var code_banque = ($('input[name=form\\[code_banque\\]]', '#form-rib').val());
            var code_banque = ($('input[name=form\\[code_banque\\]]', '#form-rib').val());
            var code_guichet = ($('input[name=form\\[code_guichet\\]]', '#form-rib').val());
            var numero_de_compte = ($('input[name=form\\[numero_de_compte\\]]', '#form-rib').val());
            var cle_rib = ($('input[name=form\\[cle_rib\\]]', '#form-rib').val());
            var iban = ($('input[name=form\\[iban\\]]', '#form-rib').val());
            if (bank_name_is_show == true) {
                var bank_name = ($('input[name=form\\[bank_name\\]]', '#form-rib').val());
            }
            var token = $('input[name=form\\[_token\\]]', '#form-rib').val();

            $('.loader-iban').show();
            $.ajax({
                url: '/souscription-step3-rib',
                type: 'POST',
                data: {
                    'form[bic]': bic,
                    'form[bank_name]': bank_name,
                    'form[code_banque]': code_banque,
                    'form[code_guichet]': code_guichet,
                    'form[numero_de_compte]': numero_de_compte,
                    'form[iban]': iban,
                    'form[cle_rib]': cle_rib,
                    'form[_token]': token
                },
                dataType: 'json',
                success: function(data, statut) {
                    remove_error_from_rib();
                    $('.loader-iban').hide();
                    if (data.length != 0) {
                        if (data.hasOwnProperty('CSRF')) {
                            $('#popup-page-expired').css('display', 'flex');
                        }
                        if (data.hasOwnProperty('rib')) {
                            $('input[name=form\\[code_banque\\]]', '#form-rib').addClass('error-field');
                            $('input[name=form\\[code_guichet\\]]', '#form-rib').addClass('error-field');
                            $('input[name=form\\[numero_de_compte\\]]', '#form-rib').addClass('error-field');
                            $('input[name=form\\[cle_rib\\]]', '#form-rib').addClass('error-field');
                            var text = '<li>' + data.rib + '</li>';
                            $('input[name=form\\[cle_rib\\]]', '#form-rib').parent().parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('iban')) {
                            $('input[name=form\\[iban\\]]', '#form-rib').addClass('error-field');
                            var text = '<li>' + data.iban + '</li>';
                            $('input[name=form\\[iban\\]]', '#form-rib').parent().parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('bic')) {
                            var text = '<li>' + data.bic + '</li>';
                            $('input[name=form\\[bic\\]]', '#form-rib').parent().parent().find('.errors-list').html(text);
                            $('#form-rib #form_bank_name_container').show();
                            bank_name_is_show = true;
                            $('input[name=form\\[bank_name\\]]', '#form-rib').addClass('error-field');
                            var text = '<li>' + data.bank_name + '</li>';
                            $('input[name=form\\[bank_name\\]]', '#form-rib').parent().parent().find('.errors-list').html(text);
                        }
                    } else {
                        $('#step-3-ss-step-3').addClass('show').attr('aria-expanded', 'true');
                        $('#step-3-ss-step-3').closest('.accordion-item').removeClass('disabled').addClass('current');
                        var toTop = $('header').height() + $('.breadcrumb').height() + $('#timeline-souscription').height();
                        $('html, body').animate({ scrollTop: toTop }, 500).delay(250);
                        $('#step-3-ss-step-2').removeClass('show').attr('aria-expanded', 'false');
                        $('#step-3-ss-step-2').closest('.accordion-item').removeClass('current').addClass('completed');
                    }

                    /*=====================================
                     =            TAGGAGE      =
                     =====================================*/
                    ga('send', 'pageview', '/souscription-en-ligne/titulaire_rib', '');
                },

                error: function(resultat, statut, erreur) {
                    document.location.href = "/500";
                }

            });
        });


        $("#form-addr-rib").keyup(function(e) {
            var target = $(e.target).attr("id");
            if ($('#' + target, '#form-addr-rib').hasClass('error-field')) {
                $('#' + target, '#form-addr-rib').removeClass('error-field');
                $('#' + target, '#form-addr-rib').parent().find('.errors-list').html('');
            }
        });

        function remove_error_from_addr_rib() {
            $('.errors-list-standingOrder').html('');
            $('.errors-list-cgv').html('');
        }

        $('#form-addr-rib').submit(function(e) {
            e.preventDefault();
            var addressNum = ($('input[name=form\\[addressNum\\]]', '#form-addr-rib').val());
            var addressName = ($('input[name=form\\[addressName\\]]', '#form-addr-rib').val());
            var addressMore = ($('input[name=form\\[addressMore\\]]', '#form-addr-rib').val());
            var addressPostal = ($('input[name=form\\[addressPostal\\]]', '#form-addr-rib').val());
            var addressCity = ($('input[name=form\\[addressCity\\]]', '#form-addr-rib').val());
            var standingOrder = ($('input[name=form\\[standingOrder\\]]:checked', '#form-addr-rib').val());
            var cgv = ($('input[name=form\\[cgv\\]]:checked', '#form-addr-rib').val());

            var token = $('input[name=form\\[_token\\]]', '#form-addr-rib').val();
            $('.loader-validation').show();
            $.ajax({
                url: '/souscription-step3-titulaire',
                type: 'POST',
                data: {
                    'form[addressNum]': addressNum,
                    'form[addressName]': addressName,
                    'form[addressMore]': addressMore,
                    'form[addressPostal]': addressPostal,
                    'form[addressCity]': addressCity,
                    'form[standingOrder]': standingOrder,
                    'form[cgv]': cgv,
                    'form[_token]': token
                },
                dataType: 'json',
                success: function(data, statut) {

                    if (data == false || data == null) {
                        document.location.href = "/500";
                    }

                    // Form
                    $('.loader-validation').hide();
                    remove_error_from_addr_rib();
                    if (data.hasOwnProperty('id')) {
                        
                        $('.cmde-number').html('nÂ° ' + data.id);

                        // Collapse step-3 (and any open sub-steps) so the confirmation panel is not hidden below it
                        $('#step-3-ss-step-1, #step-3-ss-step-2, #step-3-ss-step-3')
                            .removeClass('show').attr('aria-expanded', 'false');
                        $('#step-3-ss-step-1, #step-3-ss-step-2, #step-3-ss-step-3')
                            .closest('.accordion-item').removeClass('current').addClass('completed');
                        $('#step-3').removeClass('show').attr('aria-expanded', 'false');
                        $('#step-3').closest('.accordion-item').removeClass('current').addClass('completed');

                        // Open step-4 (confirmation)
                        $('#step-4').addClass('show').attr('aria-expanded', 'true');
                        $('#step-4').closest('.accordion-item').removeClass('disabled').addClass('current');

                        // Scroll to the confirmation section itself
                        var step4Top = $('#step-4').closest('.accordion-item').offset().top
                            - ($('header').outerHeight() || 0);
                        $('html, body').animate({ scrollTop: step4Top }, 250);
                        // Timeline
                        $('#timeline-souscription #steps li[data-step="1"]').removeClass('completed').addClass('disabled');
                        $('#timeline-souscription #steps li[data-step="2"]').removeClass('completed').addClass('disabled');
                        $('#timeline-souscription #steps li[data-step="3"]').removeClass('current').addClass('disabled');
                        $('#timeline-souscription #steps li[data-step="4"]').removeClass('disabled').addClass('current');
                        // Panel
                        /*
                        $('#process-souscription .panel').not('.process-souscription').hide();
                        $('.panel-confirmation .panel-heading').hide();*/
                        /*=====================================
                         =            TAGGAGE      =
                         =====================================*/
                        ga('send', 'event', 'Parcours_Titulaire', 'click-link', 'Confirmer la commande');

                        var valueOptions = 0;
                        ga('require', 'ecommerce');
                        if (choice1) {
                            valueOptions += $('#option-second-medaillon').val();
                            ga('send', 'event', 'Parcours_Offre', 'click-link', 'Medaillon_Gratuit');
                            ga('ecommerce:addProduct', {
                                'id': 'P1',
                                'name': 'Souscription',
                                'price': '24.90',
                                'quantity': 1
                            });

                        }

                        if (choice2) {
                            valueOptions += $('#option-chute').val();
                            ga('send', 'event', 'Parcours_Offre', 'click-link', 'Detecteur_Chute');
                            ga('ecommerce:addProduct', {
                                'id': 'P2',
                                'name': 'Detecteur_Chute',
                                'price': '6',
                                'quantity': 1
                            });

                        }

                        if (choice3) {
                            valueOptions += $('#option-fumee').val();
                            ga('send', 'event', 'Parcours_Offre', 'click-link', 'Detecteur_Fumee');
                            ga('ecommerce:addProduct', {
                                'id': 'P2',
                                'name': 'Detecteur_Fumee',
                                'price': '3',
                                'quantity': 1
                            });

                        }



                        if (!choice1 && !choice2 && !choice3) {
                            ga('send', 'event', 'Parcours_Offre', 'click-link', 'Aucune_Option');
                        }

                        if (subsIsBenef == 1) {
                            ga('send', 'event', 'Parcours_Beneficiaire', 'click-link', 'Oui');
                        } else {
                            ga('send', 'event', 'Parcours_Beneficiaire', 'click-link', 'Non');
                        }

                        if (subsIsContact == 1) {
                            ga('send', 'event', 'Parcours_Contact', 'click-link', 'Oui');
                        } else {
                            ga('send', 'event', 'Parcours_Contact', 'click-link', 'Non');
                        }

                        if (secondContact != 0 || secondContact) {
                            ga('send', 'event', 'Parcours_Contact', 'click-link', 'Ajouter_Contact');
                        }

                        // ga('ecommerce:addTransaction', {
                        //     'id': 'transaction',
                        //     'affiliation': '',
                        //     'revenue': valueOptions.toString(), // Grand Total.
                        //     'shipping': '',
                        //     'tax': ''
                        // });
                        ga('ecommerce:setAction', 'purchase', {
                            'id': 'transaction',
                            'revenue': valueOptions.toString()
                        });

                        ga('ecommerce:send');
                        $.urlParam = function(name) {
                            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
                            if (!results) {
                                return 0;
                            }

                            return results[1];
                        }
                        if ($.urlParam('landing')) {
                            ga('send', 'event', 'LandingPage', 'click-link', 'Souscription');
                        }
                        goog_report_conversion();

                        ga('send', 'pageview', '/souscription-en-ligne/confirmation', '');
                    } else {
                        if (data.hasOwnProperty('CSRF')) {
                            $('#popup-page-expired').css('display', 'flex');
                        }
                        if (data.hasOwnProperty('error')) {
                            $('#popup-page-expired').css('display', 'flex');
                        }
                        if (data.hasOwnProperty('titulaire_standingOrder')) {
                            $('.errors-list-standingOrder').html('<li>' + data.titulaire_standingOrder + '</li>');
                        }
                        if (data.hasOwnProperty('titulaire_cgv')) {
                            $('.errors-list-cgv').html('<li>' + data.titulaire_cgv + '</li>');
                        }
                        if (data.hasOwnProperty('addressName')) {
                            $('input[name=form\\[addressName\\]]', '#form-addr-rib').addClass('error-field');
                            var text = '<li>' + data.addressName + '</li>';
                            $('input[name=form\\[addressName\\]]', '#form-addr-rib').parent().parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('addressMore')) {
                            $('input[name=form\\[addressMore\\]]', '#form-addr-rib').addClass('error-field');
                            var text = '<li>' + data.addressMore + '</li>';
                            $('input[name=form\\[addressMore\\]]', '#form-addr-rib').parent().parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('addressPostal')) {
                            $('input[name=form\\[addressPostal\\]]', '#form-addr-rib').addClass('error-field');
                            var text = '<li>' + data.addressPostal + '</li>';
                            $('input[name=form\\[addressPostal\\]]', '#form-addr-rib').parent().parent().find('.errors-list').html(text);
                        }
                        if (data.hasOwnProperty('addressCity')) {
                            $('input[name=form\\[addressCity\\]]', '#form-addr-rib').addClass('error-field');
                            var text = '<li>' + data.addressCity + '</li>';
                            $('input[name=form\\[addressCity\\]]', '#form-addr-rib').parent().parent().find('.errors-list').html(text);
                        }
                    }


                },

                error: function(resultat, statut, erreur) {
                    document.location.href = "/500";
                }

            });
        });


    });


    /*=====================================
    =            RESIZE FUNCTION          =
    =====================================*/

    $(window).resize(function() {


    });

    /*=====  End of RESIZE FUNCTION  =====*/

    /*=====================================
    =            SCROLL FUNCTION          =
    =====================================*/

    $(window).scroll(function() {});

    /*=====  End of SCROLL FUNCTION  =====*/

});
